import React from 'react';
import logo from './logo.svg';
import './index.css';
import Body from './components/Body';



function App() {
  return (
    <div className="App">
      <Body/>
    </div>
  );
}

export default App;
